export default {
	InvitationCode: "Inbjudningskod",
	CreditScore: "Kreditbetyg",
	MyFinancial: {
		title: "Min Finansiella",
		menu: ["Insättning", "Uttag", "Transaktion"]
	},
	MyDetail: {
		title: "Min Detalj",
		menu: ["Personlig Information", "Betalningsmetoder"]
	},
	Other: {
		title: "Övrigt",
		menu: ["Kontakta oss", "Meddelanden", "Byt språk"]
	},
	Amount: ["Plånbokssaldo", "Fryst Saldo", "Dagens Intäkter"],
	Logout: {
		title: "Logga ut",
		content: "Är du säker på att du vill logga ut?"
	}
};
